import { c as _c } from "react/compiler-runtime";
import { Flex } from "@opensea/ui-kit";
import { HeroHeaderViewToggleSkeleton } from "@/components/hero-header/HeroHeaderViewToggleSkeleton";
import { StatDisplaySkeleton } from "@/components/stats/StatDisplay";
export function CollectionStatsSkeleton(t0) {
  const $ = _c(2);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "on-background" : t1;
  let t2;
  if ($[0] !== variant) {
    t2 = <Flex className="items-center justify-between gap-6 overflow-visible md:gap-8"><StatDisplaySkeleton variant={variant} /><HeroHeaderViewToggleSkeleton variant={variant} /></Flex>;
    $[0] = variant;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}